module.exports = __webpack_public_path__ + "img/comment-plus-icon.da9facc1.svg";